const team = {
  invitations: {
    accept: {
      missingInfo: 'This invitation link is missing required information.',
      defaultError: 'Invitation not found or no longer available.',
      toastAcceptError: 'Unable to accept invitation.',
      toastDeclineError: 'Unable to decline invitation.',
      issueBadge: 'Invitation issue',
      errorHeading: "We couldn’t open this invitation",
      errorFollowup: 'If you believe this is a mistake, reach out to the workspace owner and request a new link.',
      errorAlert:
        'Invitation tokens expire or are revoked once they’re used. Ask the team owner to generate a fresh invitation and check that you’re using the latest email they sent.',
      checkingTitle: 'Checking your invitation…',
      checkingSubtitle: 'We’re verifying the workspace and permissions tied to this link.',
      invitationBadge: 'Invitation',
      joinHeading: 'Join {{team}}',
      joinSubtitle:
        'Step into the shared workspace for {{workspace}}. Accept the invitation to unlock shared seats, billing insights, and automation tools curated for this team.',
      roleLabel: 'Role',
      roleNote:
        'You’ll join with permissions set by your workspace owner. You can adjust your profile after you sign in.',
      expiresLabel: 'Invitation expires',
      confirmBy: 'Confirm by {{date}} to keep your reserved seat.',
      confirmSoon: 'Confirm soon to keep your reserved seat.',
      workspaceFallback: 'your workspace',
      timeSoon: 'soon',
      detailsHeading: 'Invitation details',
      sentTo: 'Sent to {{email}}',
      sentBy: 'by {{name}}',
      sentOn: 'on {{date}}',
      workspaceLabel: 'Workspace',
      teamLabel: 'Team',
      statusLabel: 'Status',
      emailOnFileLabel: 'Email on file',
      confirmEmailNote:
        'Confirm the email you’ll use to join this workspace. We’ll match it with the invitation before activating your account.',
      emailLabel: 'Your email',
      emailPlaceholder: 'you@example.com',
      emailNote: 'We’ll confirm this email matches the invitation before completing the action.',
      confirmationNotice: 'Confirmation will be sent to {{email}}.',
      invitedBy: 'Invited by {{name}}.',
      seatProvided: 'Seat provided by the workspace owner.',
      expiresOn: 'Expires on {{date}}.',
      declinedAlert:
        'You’ve declined this invitation. You can close this tab or contact the workspace owner if you change your mind.',
      acceptCta: 'Accept invitation',
      accepting: 'Accepting…',
      declineCta: 'Decline',
      cancelDecline: 'Cancel decline',
      declinePrompt: 'Let the team know why you’re passing (optional)',
      declinePlaceholder: 'Not joining this project right now…',
      sendDecline: 'Send decline',
      declining: 'Declining…',
      declineNote: 'We’ll notify the workspace owner immediately.',
    },
  },
} as const

export default team
